import {reactive} from '@vue/reactivity'

export class WindowDimensions {
    public height: number = window.innerHeight
    public width: number = window.innerWidth;
}

class BreakpointUtil {

    dimensions: WindowDimensions  = reactive(new WindowDimensions())

    constructor() {
        this.onWindowResize()
        //Do NOT remove the arrow function below.
        // if you just pass a function, it will be bound to the global 'window' element
        window.addEventListener('resize', () => {
            this.onWindowResize()
        })
    }

    onWindowResize(): void {
        this.dimensions.width = window.innerWidth
        this.dimensions.height = window.innerHeight
    }

    get isOnMobile(): boolean {
        return this.dimensions.width < 992
    }

    get isOnXl(): boolean {
        return this.dimensions.width < 1200
    }

}

const breakpointUtil: BreakpointUtil = new BreakpointUtil()
export default breakpointUtil
